export default __webpack_public_path__ + "static/sample-ac0398d4ca249e56858868cab06bc382.pdf";